export default "__VITE_ASSET__CCs0nAjN__"